import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { PROFILE_QUERY_KEYS } from "../queryKeys";
import { getUserTrophies } from "../services/trophies.service";
import { TrophiesResponse } from "../types/trophies.types";

export const useUserTrophies = (userId: string | null, limit: number, offset: number = 0) => {
  const { i18n } = useTranslation();

  return useQuery<TrophiesResponse["data"], Error>({
    queryKey: [...PROFILE_QUERY_KEYS.trophies(userId!, limit, offset), i18n.language],
    queryFn: async () => {
      const response = await getUserTrophies(userId!, limit, offset);
      return response.data;
    },
    enabled: !!userId,
  });
};
